import * as actions from '../actions';

import fetchGroupSets from './fetchGroupSets.data.reducer';
import fetchGroupSet from './fetchGroupSet.data.reducer';
import fetchGroupSetsNoGroupStudents from './fetchGroupSetsNoGroupStudents.data.reducer';
import addGroupSet from './addGroupSet.data.reducer';
import editGroupSet from './editGroupSet.data.reducer';
import deleteGroupSet from './deleteGroupSet.data.reducer';

import addGroup from './addGroup.data.reducer';
import addGroups from './addGroups.data.reducer';
import editGroup from './editGroup.data.reducer';
import deleteGroup from './deleteGroup.data.reducer';
import generateGroups from './generateGroups.data.reducer';

import searchParticipantsInGroups from './searchParticipantsInGroups.data.reducer';

const initialState = {
  sets: {},
  // TODO: investigate whether we use this property; consider removing
  groups: {},
  searchedSets: [],
};

const reducerMap = {
  [actions.GROUPS_FETCH_GROUP_SETS]: fetchGroupSets,
  [actions.GROUPS_FETCH_GROUP_SETS_NO_GROUP_STUDENTS]:
    fetchGroupSetsNoGroupStudents,
  [actions.GROUPS_FETCH_GROUP_SET]: fetchGroupSet,
  [actions.GROUPS_ADD_GROUP_SET]: addGroupSet,
  [actions.GROUPS_EDIT_GROUP_SET]: editGroupSet,
  [actions.GROUPS_DELETE_GROUP_SET]: deleteGroupSet,

  [actions.GROUPS_ADD_GROUP]: addGroup,
  [actions.GROUPS_ADD_GROUPS]: addGroups,
  [actions.GROUPS_EDIT_GROUP]: editGroup,
  [actions.GROUPS_DELETE_GROUP]: deleteGroup,
  [actions.GROUPS_GENERATE_GROUPS]: generateGroups,

  [actions.GROUPS_PARTICIPANT_SEARCH]: searchParticipantsInGroups,
};

export default (state = initialState, action) => {
  const reducer = reducerMap[action.type];
  if (typeof reducer === 'undefined') return state;
  return reducer(state, action);
};
